import api from './client';

export const openingApi = {
  previewStock: (file: File) => { const fd = new FormData(); fd.append('file', file); return api.post('/opening/stock/preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importStock:  (data: any)  => api.post('/opening/stock/import', data),
  previewAR:    (file: File) => { const fd = new FormData(); fd.append('file', file); return api.post('/opening/ar/preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importAR:     (data: any)  => api.post('/opening/ar/import', data),
  previewAP:    (file: File) => { const fd = new FormData(); fd.append('file', file); return api.post('/opening/ap/preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importAP:     (data: any)  => api.post('/opening/ap/import', data),
  previewCOA:   (file: File) => { const fd = new FormData(); fd.append('file', file); return api.post('/opening/coa/preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importCOA:    (data: any)  => api.post('/opening/coa/import', data),
};
